import React, {Component} from 'react';
import './Format.css';

class Format extends Component {


    render() {
        if (!('Format' in this.props.entry.fields)) {
            console.log(this.props.entry);
            return null;
        }
        let className = "badge badge-";
        let text = this.props.entry.fields.Format[0];

        switch (this.props.entry.fields.Format[0]) {
            case "Film":
                className += "film";
                break;
            case "En débat":
            case "Débat":
                className += "debat";
                text = "Débat";
                break;
            case "Atelier":
                className += "atelier";
                break;
            case "Moments musicaux":
            case "Musique":
                className += "musique";
                text = "Musique";
                break;
            case "Spectacles":
            case "Spectacle":
                text = "Spectacle"
                className += "spectacle";
                break;
            case "En action":
                className += "action";
                break;
            case "Présentation":
                className += "presentation";
                break;
            case "Conférence":
                className += "conference";
                break;
            case "Evénement":
                className += "events";
                break;
        }

        return (
            <div className={className}>
                {text}
            </div>
        );
    }
}

export default Format;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCardsV2/Format.js